import { useMemo, useState } from "react";
import MultipleLineAndBarChart from "../../../components/charts/MultipleLineAndBarChart";
import StatisticsPeriodToggle from "./StatisticsPeriodToggle";
import { buildCollectionByFluxChartData } from "../utils/collectionChartUtils";

const CollectionChartSection = ({ data, t, chartPlotRef }) => {
  const [periodMode, setPeriodMode] = useState("month");

  const { dataSetsCollectionByFluxChart, labelsByTimeChart } = useMemo(
    () => buildCollectionByFluxChartData(data, periodMode),
    [data, periodMode],
  );

  return (
    <article className="statistics-card w-full min-w-0">
      <div className="dashboard-chart-heading dashboard-chart-heading-row">
        <div className="dashboard-chart-heading-text">
          <h5 className="dashboard-chart-title">
            {t("Rotations by waste category")}
          </h5>
          <p className="dashboard-chart-subtitle">
            {t("rotationChart.subtitle")}
          </p>
        </div>
        <StatisticsPeriodToggle
          activeMode={periodMode}
          onModeChange={setPeriodMode}
          t={t}
        />
      </div>

      <div className="relative w-full min-w-0 h-[320px]">
        <div className="absolute inset-0" ref={chartPlotRef}>
          <MultipleLineAndBarChart
            stackedChart={false}
            type="bar"
            borderWidthChart={1}
            labelsChart={labelsByTimeChart}
            aspectRatioChart={1.8}
            datasetsChart={dataSetsCollectionByFluxChart}
            indexAxisChart="x"
            maintainAspectRatioChart={false}
            displayGrid={true}
            displayTicks={true}
            xAxisType={periodMode === "week" ? "category" : "time"}
            reverseChart={false}
            displayLegend={true}
            displayTooltip={true}
            messageLabelTooltip={t("Collections")}
            unitValueChart=""
            maxYAxis={null}
            maxBarThicknessChart={100}
            categoryPercentageChart={0.7}
            timeUnitChart="month"
          />
        </div>
      </div>
    </article>
  );
};

export default CollectionChartSection;
